export const PLAYER_COMMUNICATION = {
    WEBSOCKET: 'websocket',
    IPC: 'ipc',
    INLINE: 'inline',
};
